module.exports = __webpack_public_path__ + "img/app-settings.575fa62a.svg";